import { Drawer, Grid, Typography, Divider, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Button, NumberField, SmSpace, TextField } from 'm2m.components';
import { InstrumentoFinanceiro, InvestidorResponse } from 'common/genericTypes';
import { OfertaPrimariaInvestidor } from 'store/modules/operacoes/registro';
import InvestidorAutoComplete from 'components/operacoes/investidorAutoComplete';

import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { getQuantityType } from 'utils/instrumentoFinanceiroUtils';

interface Props {
  open: boolean;
  onClose(): void;
  investidores: Array<InvestidorResponse>;
  handleOfertaPrimariaSubmit(investidor: OfertaPrimariaInvestidor): void;
  tipoInstrumentoFinanceiro?: InstrumentoFinanceiro;
}

const InvestidorDrawer: React.FC<Props> = (props) => {
  const [investidorId, setInvestidorId] = useState<string>("");
  const [quantidade, setQuantidade] = useState<number>(0);
  const [precoUnitario, setPrecoUnitario] = useState<number>(0);
  const [investidor, setInvestidor] = useState<InvestidorResponse | null>(null);
  const [investidorDrawerFulFilled, setInvestidorDrawerFulFilled] = useState<boolean>(false);
  const operacao = useSelector((state: RootState) => state.operacao);
  const criteriosRemuneracao = useSelector((state: RootState) => state.operacao.criteriosRemuneracao)
  const [valorOriginal, setValorOriginal] = useState<number | null>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)


  useEffect(() => {
    if (criteriosRemuneracao?.valorNominalUnitarioEmissao) {
      setValorOriginal(criteriosRemuneracao.valorNominalUnitarioEmissao);
      setPrecoUnitario(criteriosRemuneracao.valorNominalUnitarioEmissao);
    }
  }, [criteriosRemuneracao]);

  useEffect(() => { }, [precoUnitario]);



  const resetInvestidorDrawer = () => {
    setQuantidade(0);
    setInvestidorId("");
    setInvestidor(null);
    setPrecoUnitario(valorOriginal || 0)
  };


  const handleAddInvestidorClick = () => {

    if (valorOriginal !== null && precoUnitario !== valorOriginal) {
      setDialogOpen(true);
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    props.handleOfertaPrimariaSubmit({
      investidorId,
      quantidade,
      precoUnitario: precoUnitario,
      contaDeposito: investidor?.contaDeposito ?? '',
      cpfCnpj: investidor?.cpfCnpj ?? '',
    });
    handleClosure();

  };

  const handleClosure = () => {
    resetInvestidorDrawer();
    props.onClose();
  };


  const handleDialogClose = (confirm: boolean) => {
    setDialogOpen(false);
    if (!confirm && valorOriginal !== null) {
      setPrecoUnitario(valorOriginal);
    }
  };

  useEffect(resetInvestidorDrawer, []);

  useEffect(() => {
    if (investidorId && props.investidores) {
      const inv = props.investidores.find((x) => x.id === investidorId) ?? null;
      setInvestidor(inv);
    }
  }, [investidorId, setInvestidor, props.investidores]);

  useEffect(() => {
    setInvestidorDrawerFulFilled(quantidade > 0 && !!investidor && precoUnitario > 0);
  }, [quantidade, investidor, precoUnitario]);


  return (
    <>

      <Drawer
        anchor="right"
        open={props.open}
        onClose={handleClosure}
        PaperProps={{ style: { padding: '40px', width: 520 } }}
      >
        <Grid container>
          <Grid item md={12}>
            <Typography variant="h3">{'Adicionar Investidor'}</Typography>
            <SmSpace />
          </Grid>
          <Grid item md={12}>
            <Divider variant="fullWidth" />
            <SmSpace />
          </Grid>
          <Grid item md={12}>
            <InvestidorAutoComplete
              label="CPF/CNPJ Investidor"
              investidores={props.investidores}
              investidor={investidor}
              onChange={(value: InvestidorResponse | null) => {
                setInvestidor(value);
                setInvestidorId(value?.id ?? "")
              }}
            />
            <SmSpace />
            {!!investidor && (
              <>
                <TextField label="Conta Depósito" onChange={(value) => { }} value={investidor.contaDeposito} disabled />
                <SmSpace />
              </>
            )}
            <NumberField
              label="Quantidade"
              value={quantidade}
              onChange={(value) => setQuantidade(value as number)}
              numberType={getQuantityType(props.tipoInstrumentoFinanceiro)}
              required
            />
            <SmSpace />
            <NumberField
              label="PU"
              value={precoUnitario || criteriosRemuneracao?.valorNominalUnitarioEmissao || 0}
              onChange={(value) => setPrecoUnitario(value as number)}
              numberType="eightDecimals"
              required
            />

            <SmSpace />
            <Button
              variant="contained"
              fullWidth
              color="primary"
              onClick={handleAddInvestidorClick}
              disabled={!investidorDrawerFulFilled}
            >
              {'Adicionar Investidor'}
            </Button>
          </Grid>
        </Grid>
      </Drawer>
      <Grid>
        <Dialog open={dialogOpen} onClose={() => handleDialogClose(false)}>
          <DialogTitle>Alteração no Preço Unitário</DialogTitle>
          <DialogContent>
            <Typography>
              O valor do preço unitário {valorOriginal} está sendo alterado para{' '}
              {precoUnitario}. Deseja continuar?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDialogClose(false)} color="default">
              {' Cancelar'}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleSubmit();
                handleDialogClose(false);
              }}
            >
              {'Confirmar'}
            </Button>

          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

export default InvestidorDrawer;
